<template>
  <div id="wrapper" >
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "mainBox",
}
</script>
<style scoped>

</style>
